import { createClinicalSession, createPhoneCall } from '@/services/api/voiceApi'
import { FEATURES } from '@/constants/features'
import { POSTHOG_FLAGS } from '@/constants/posthogFlags'
import { canAccessFeature } from '@/utils/access'
import { isPostHogFlagEnabled } from '@/utils/posthogFlags'

/** @type {import('@/services/api/schema').components['schemas']['WorkTypeKindEnum']} */
export const ENGAGEMENT_KIND = 'engagement'


export const ENGAGEMENTS = {
  clinicalEngagement: {
    label: 'Clinical Engagement',
    description: 'Care session with the patient: video, phone or recorded audio',
    icon: ['fas', 'user-doctor'],
    iconClass: 'text-primary-600',
    tileClass: 'bg-primary-50',
  },
  phoneCall: {
    label: 'Care Coordination Call',
    description: 'Call the care team, DME company or other contacts about the patient',
    icon: ['fas', 'phone'],
    iconClass: 'text-green-600',
    tileClass: 'bg-green-50',
  },
}

export function isEngagementWorkType(workType) {
  return workType?.kind === ENGAGEMENT_KIND
}

export function canStartPhoneCall() {
  return canAccessFeature(FEATURES.COMPONENT_TELEHEALTH_PHONE)
    && isPostHogFlagEnabled(POSTHOG_FLAGS.TELEHEALTH_THREE_WAY_CALLING)
}

export function phoneCallPath(workId) {
  return `/work/phonecall/${workId}`
}

export function clinicalEngagementPath(workId) {
  return `/work/clinicalengagement/${workId}`
}

async function createAndOpen(create, pathFor) {
  const tab = window.open('', '_blank')
  try {
    const work = await create()
    const path = pathFor(work.work_id)
    if (tab) tab.location.href = path
    else window.open(path, '_blank')
    return work
  } catch (error) {
    tab?.close()
    throw error
  }
}

export function startPhoneCall({ opportunityId, taskId }) {
  if (!taskId) return Promise.reject(new Error('A task is required to start a phone call.'))
  const body = { task_id: taskId }
  if (opportunityId) body.opportunity_id = opportunityId
  return createAndOpen(() => createPhoneCall(body), phoneCallPath)
}

export function startClinicalEngagement({ opportunityId, taskId }) {
  if (!opportunityId) return Promise.reject(new Error('An opportunity is required to start a clinical engagement.'))
  return createAndOpen(() => createClinicalSession({ opportunityId, taskId }), clinicalEngagementPath)
}
